import { default as domainTeacherIndicator } from './indicator/services'
import { default as teacherPositionCategory } from './position-category/services'

export default { 
	domainTeacherIndicator,
	teacherPositionCategory	
}